import { render, staticRenderFns } from "./Senderos.vue?vue&type=template&id=5c416543&scoped=true"
import script from "./Senderos.vue?vue&type=script&lang=js"
export * from "./Senderos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c416543",
  null
  
)

export default component.exports